import styled from "styled-components";
import FlexContainer from "~/spocketUI/components/FlexContainer";
import { getColor, getSize, responsive } from "~/spocketUI/helpers/style";

export const BannerContainer = styled(FlexContainer)`
  flex-direction: column;
  height: auto;
  padding: ${getSize(1.8)};
  text-align: center;
  width: 100%;
  background-color: ${getColor("white")};
  border-radius: 6px;
  gap: ${getSize(2.6)};
  margin: ${getSize(3.0)} 0;

  ${responsive("laptop")} {
    height: ${getSize(10.8)};
    padding: ${getSize(2.9)} 0;
    flex-direction: row;
  }
`;

export const BannerText = styled.span`
  font-size: ${getSize(1.6)};
  font-weight: 500;
`;